import React, { Component, Fragment } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

// component imports
import PrivateRoute from './routes/PrivateRoute';
import ForgotPassword from './components/ForgotPassword';
import PasswordSent from './components/PasswordSent';
import PublicRoute from './routes/PublicRoute';
import Login from './components/login';
import AccomodationDetails from './components/AccomodationDetails';
import Accomodations from './components/Accomodations';
import NotFound from './components/NotFound';
import SideBar from './components/SideBar';
import Dashboard from './components/Dashboard';
import Prints from './components/Prints';
import Profile from './components/Profile';
// import ProfileHeader from './components/ProfileHeader';
import RegisteredCourses from './components/RegisteredCourses';
import RegisterCourses from './components/RegisterCourses';
import CourseDetails from './components/CourseDetails';
import Fees from './components/Fees';
import FeeDetails from './components/FeeDetails';
import TransactionDetails from './components/TransactionDetails';
import TransactionHistory from './components/TransactionHistory';

// context imports
import { AuthConsumer } from './context/AuthContext';

export const history = createBrowserHistory();

class App extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <Router history={history}>
            <Fragment>
              <AuthConsumer>
                {({ isLoggedIn }) => {
                  return isLoggedIn ? (
                    <>
                      {' '}
                      <SideBar />
                      {/* <ProfileHeader />{" "} */}
                    </>
                  ) : null;
                }}
              </AuthConsumer>
              <AuthConsumer>
                {({ isLoggedIn }) => {
                  return (
                    <Fragment>
                      <Switch>
                        <PrivateRoute
                          exact={true}
                          path="/"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Dashboard} // currently render accomodation for now, change later on full deploy
                        />
                        <PrivateRoute
                          exact={true}
                          path="/dashboard"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Dashboard}
                        />
                        <PrivateRoute
                          path="/course/details/:courseId"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={CourseDetails}
                        />
                        <PrivateRoute
                          path="/courses/registered"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={RegisteredCourses}
                        />
                        <PrivateRoute
                          path="/courses"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={RegisterCourses}
                        />
                        <PrivateRoute
                          path="/prints"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Prints}
                        />
                        <PrivateRoute
                          path="/transaction/details/:transactionId/"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={TransactionDetails}
                        />
                        <PrivateRoute
                          path="/result"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={testNavComponent}
                          title={'result screen'}
                        />
                        <PrivateRoute
                          path="/fees"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Fees}
                        />
                        <PrivateRoute
                          path="/fee/details/:id"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={FeeDetails}
                        />{' '}
                        */}
                        <PrivateRoute
                          path="/accomodations"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Accomodations}
                        />
                        <PrivateRoute
                          path="/accomodation/details/:accommodationId/"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={AccomodationDetails}
                        />
                        <PrivateRoute
                          path="/profile"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={Profile}
                        />
                        <PrivateRoute
                          path="/transactions"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={TransactionHistory}
                        />
                        <PrivateRoute
                          path="/prints"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={testNavComponent}
                          title={'prints screen'}
                        />
                        <PrivateRoute
                          path="/more"
                          isLoggedIn={isLoggedIn} //assume user is logged in
                          component={testNavComponent}
                          title={'more screen'}
                        />
                        <PublicRoute
                          exact={true}
                          path="/login"
                          isLoggedIn={isLoggedIn} //assume user is not logged in
                          component={Login}
                        />
                        <PublicRoute
                          exact={true}
                          path="/password_sent"
                          isLoggedIn={isLoggedIn} //assume user is not logged in
                          component={PasswordSent}
                        />
                        <PublicRoute
                          exact={true}
                          path="/forgotpassword"
                          isLoggedIn={isLoggedIn} //assume user is not logged in
                          component={ForgotPassword}
                        />
                        <Route isLoggedIn={false} component={NotFound} />
                      </Switch>
                    </Fragment>
                  );
                }}
              </AuthConsumer>
            </Fragment>
          </Router>
        </div>
      </div>
    );
  }
}

const testNavComponent = props => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <span> {props.title} </span>
  </div>
);

export default App;
